import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import client from '../api/client';

function MentorList({ token }) {
    const [mentors, setMentors] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchMentors = async () => {
            try {
                const response = await client.get('/mentors');
                setMentors(response.data.mentors);
            } catch (err) {
                console.error('Failed to fetch mentors', err);
            } finally {
                setLoading(false);
            }
        };

        fetchMentors();
    }, [token]);

    if (loading) return <div>Loading mentors...</div>;

    return (
        <div>
            <h2 style={{ marginBottom: '20px' }}>Choose a Mentor</h2>
            <div className="grid">
                {mentors.map((mentor) => (
                    <div
                        key={mentor.id}
                        className="card mentor-card"
                        onClick={() => navigate(`/chat/${mentor.id}`)}
                    >
                        {mentor.image_url && (
                            <img
                                src={mentor.image_url}
                                alt={mentor.name}
                                style={{ width: '100%', height: '150px', objectFit: 'cover', borderRadius: '8px', marginBottom: '10px' }}
                            />
                        )}
                        <h3>{mentor.name}</h3>
                        <p style={{ fontSize: '0.9em', color: '#aaa' }}>{mentor.persona}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default MentorList;
